const drawerOpen = (state) => state.drawerOpen
const alert = (state) => state.alert
const loader = (state) => state.loader
const currentModule = (state) => state.currentModule
const currentPath = (state) => state.currentPath
const axiosHideLoader = (state) => state.axiosHideLoader
const newVersionSnackbar = (state) => state.newVersionSnackbar
const routeCount = (state) => state.routeCount
const versionCheck = (state) => state.versionCheck

export default {
  drawerOpen,
  alert,
  loader,
  currentModule,
  currentPath,
  axiosHideLoader,
  newVersionSnackbar,
  routeCount,
  versionCheck
}
